export const NO_LOCK_MANDATORY_PERIOD = 6; // mandatory lock of 6 hours applies to each No Lock deposit.
export const NO_LOCK_EARLY_WITHDRAWAL_TIME = 72; // penalty applied to no-lock withdraw if withdrawn before 72 hours after a no-lock deposit
